import { useEffect, useRef } from "react";

export const RaveModeButton = ({ onClick }) => {
  const ref = useRef(null);

  useEffect(() => {
    const id = setInterval(() => {
      const h = Math.floor(Math.random() * 360);
      ref.current?.style.setProperty("--rave", `hsl(${h} 100% 60%)`);
      ref.current?.style.setProperty("--rave2", `hsl(${(h + 140) % 360} 100% 55%)`);
    }, 180);
    return () => clearInterval(id);
  }, []);

  return (
    <button ref={ref} className="btn-mode btn-rave" onClick={onClick} data-testid="mode-button">MODE</button>
  );
};
